import { contractRead } from '@/shared/lib'
import { ethers } from 'ethers'
import { useState } from 'react'

export const convertRoleName = (rm: string) => ethers.toUtf8String(rm).replace(/\0/g, '')

const useRoles = () => {
	const [roles, setRoles] = useState<string[]>([])
	const [roleString, setRoleString] = useState<string[]>([])

	const getRoles = async (id: `0x${string}`) => {
		const result: string[] = await contractRead('SavvaNPO', 'getRoleList', [], id)
		const readable = result.map(r => convertRoleName(r))
		setRoles(result)
		setRoleString(readable)
	}

	return {
		getRoles,
		roles,
		roleString
	}
}

export default useRoles
